import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";

export const SIGNUP_URL_QUERY_PREMIUM = "?bundle=loom&edition=premium";

export const usePremiumSignupUrl = () =>
    useLocalizedHref(`/try/cloud/signup${SIGNUP_URL_QUERY_PREMIUM}`);
